var endpointMap = {
	am: {
		"pages.homepage": "translation-am.json"
	},
	"am-ET": {
		"pages.homepage": "translation-am.json"
	},
	ar: {
		"pages.homepage": "translation-ar.json"
	},
	"ar-SA": {
		"pages.homepage": "translation-ar.json"
	},
	bn: {
		"pages.homepage": "translation-bn.json"
	},
	"bn-IN": {
		"pages.homepage": "translation-bn.json"
	},
	cs: {
		"pages.homepage": "translation-cs.json"
	},
	"cs-CZ": {
		"pages.homepage": "translation-cs.json"
	},
	de: {
		"pages.homepage": "translation-de.json"
	},
	"de-DE": {
		"pages.homepage": "translation-de.json"
	},
	en: {
		"pages.homepage": "translation-en.json"
	},
	"en-CA": {
		"pages.homepage": "translation-en.json"
	},
	"en-GB": {
		"pages.homepage": "translation-en.json"
	},
	"en-IN": {
		"pages.homepage": "translation-en.json"
	},
	"en-US": {
		"pages.homepage": "translation-en.json"
	},
	es: {
		"pages.homepage": "translation-es.json"
	},
	"es-ES": {
		"pages.homepage": "translation-es.json"
	},
	"es-MX": {
		"pages.homepage": "translation-es.json"
	},
	fa: {
		"pages.homepage": "translation-fa.json"
	},
	"fa-AF": {
		"pages.homepage": "translation-fa.json"
	},
	fil: {
		"pages.homepage": "translation-fil.json"
	},
	fr: {
		"pages.homepage": "translation-fr.json"
	},
	"fr-CA": {
		"pages.homepage": "translation-fr.json"
	},
	"fr-FR": {
		"pages.homepage": "translation-fr.json"
	},
	gu: {
		"pages.homepage": "translation-gu.json"
	},
	"gu-IN": {
		"pages.homepage": "translation-gu.json"
	},
	hi: {
		"pages.homepage": "translation-hi.json"
	},
	"hi-IN": {
		"pages.homepage": "translation-hi.json"
	},
	ht: {
		"pages.homepage": "translation-ht.json"
	},
	"ht-HT": {
		"pages.homepage": "translation-ht.json"
	},
	id: {
		"pages.homepage": "translation-id.json"
	},
	"id-ID": {
		"pages.homepage": "translation-id.json"
	},
	it: {
		"pages.homepage": "translation-it.json"
	},
	"it-IT": {
		"pages.homepage": "translation-it.json"
	},
	ja: {
		"pages.homepage": "translation-ja.json"
	},
	"ja-JP": {
		"pages.homepage": "translation-ja.json"
	},
	ko: {
		"pages.homepage": "translation-ko.json"
	},
	"ko-KR": {
		"pages.homepage": "translation-ko.json"
	},
	ne: {
		"pages.homepage": "translation-ne.json"
	},
	"ne-NP": {
		"pages.homepage": "translation-ne.json"
	},
	nl: {
		"pages.homepage": "translation-nl.json"
	},
	"nl-NL": {
		"pages.homepage": "translation-nl.json"
	},
	pa: {
		"pages.homepage": "translation-pa.json"
	},
	"pa-IN": {
		"pages.homepage": "translation-pa.json"
	},
	pl: {
		"pages.homepage": "translation-pl.json"
	},
	"pl-PL": {
		"pages.homepage": "translation-pl.json"
	},
	pt: {
		"pages.homepage": "translation-pt.json"
	},
	"pt-BR": {
		"pages.homepage": "translation-pt.json"
	},
	ro: {
		"pages.homepage": "translation-ro.json"
	},
	"ro-RO": {
		"pages.homepage": "translation-ro.json"
	},
	ru: {
		"pages.homepage": "translation-ru.json"
	},
	"ru-RU": {
		"pages.homepage": "translation-ru.json"
	},
	rw: {
		"pages.homepage": "translation-rw.json"
	},
	"rw-RW": {
		"pages.homepage": "translation-rw.json"
	},
	sk: {
		"pages.homepage": "translation-sk.json"
	},
	"sk-SK": {
		"pages.homepage": "translation-sk.json"
	},
	so: {
		"pages.homepage": "translation-so.json"
	},
	"so-SO": {
		"pages.homepage": "translation-so.json"
	},
	sw: {
		"pages.homepage": "translation-sw.json"
	},
	"sw-KE": {
		"pages.homepage": "translation-sw.json"
	},
	ta: {
		"pages.homepage": "translation-ta.json"
	},
	"ta-IN": {
		"pages.homepage": "translation-ta.json"
	},
	te: {
		"pages.homepage": "translation-te.json"
	},
	"te-IN": {
		"pages.homepage": "translation-te.json"
	},
	ti: {
		"pages.homepage": "translation-ti.json"
	},
	"ti-ER": {
		"pages.homepage": "translation-ti.json"
	},
	"tl-PH": {
		"pages.homepage": "translation-fil.json"
	},
	tr: {
		"pages.homepage": "translation-tr.json"
	},
	"tr-TR": {
		"pages.homepage": "translation-tr.json"
	},
	uk: {
		"pages.homepage": "translation-uk.json"
	},
	"uk-UA": {
		"pages.homepage": "translation-uk.json"
	},
	und: {
		"pages.homepage": "translation.json"
	},
	ur: {
		"pages.homepage": "translation-ur.json"
	},
	"ur-PK": {
		"pages.homepage": "translation-ur.json"
	},
	vi: {
		"pages.homepage": "translation-vi.json"
	},
	"vi-VN": {
		"pages.homepage": "translation-vi.json"
	},
	zh: {
		"pages.homepage": "translation-zh.json"
	},
	"zh-CN": {
		"pages.homepage": "translation-zh.json"
	},
	"zh-TW": {
		"pages.homepage": "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
